import type * as lazyIndex from './lazyIndex';
import {
    createLazyComponent,
    LazyModule,
    registerLazyOrchestrator,
    LazyAction,
    type LazyComponent,
} from 'owa-bundling';
import { MessageExtensionControlPlaceholder } from './components/MessageExtensionControlPlaceholder';
import { onClickMessageExtensionFlyoutButton } from './actions/onClickMessageExtensionFlyoutButton';
export { onClickMessageExtensionFlyoutButton } from './actions/onClickMessageExtensionFlyoutButton';

import { launchAddinContextMenu } from './actions/launchAddinContextMenu';
import {
    onAddinTrigger,
    onMessageExtensionTrigger,
    onAddinSubcommandsTrigger,
    onMessageExtensionAddinsTrigger,
    onOpenAppStoreAddIns,
    onPinMessageExtensionTrigger,
} from 'owa-nova-actions';

import onLaunchMetaOsAddIn from 'owa-app-host-actions/lib/actions/onLaunchMetaOsAddIn';
import './orchestrators/preventDefaultOnAddinFlyoutClick';
import type {
    MessageExtensionControlComposeProps,
    MessageExtensionControlReadProps,
} from './components/MessageExtensionControl.types';
import type { MessageExtensionFlyoutBehavior } from '@1js/outlook-appbar-control';
import type { RefAttributes } from 'react';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MessageExtensionControl" */ './lazyIndex'),
    { name: 'MessageExtensionControl' }
);

export const MessageExtensionControlRead: LazyComponent<
    Omit<MessageExtensionControlReadProps & RefAttributes<MessageExtensionFlyoutBehavior>, 'ref'> &
        RefAttributes<MessageExtensionFlyoutBehavior>,
    MessageExtensionFlyoutBehavior,
    void
> = createLazyComponent(
    lazyModule,
    m => m.MessageExtensionControlRead,
    MessageExtensionControlPlaceholder
);
export const MessageExtensionControlCompose: LazyComponent<
    Omit<
        MessageExtensionControlComposeProps & RefAttributes<MessageExtensionFlyoutBehavior>,
        'ref'
    > &
        RefAttributes<MessageExtensionFlyoutBehavior>,
    MessageExtensionFlyoutBehavior,
    void
> = createLazyComponent(
    lazyModule,
    m => m.MessageExtensionControlCompose,
    MessageExtensionControlPlaceholder
);

export const lazyMessageExtensionsRibbonButtonOnExecute: LazyAction<
    typeof lazyIndex.messageExtensionsRibbonButtonOnExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.messageExtensionsRibbonButtonOnExecute);
export const lazyRibbonPinnedMessageExtensionOnExecute: LazyAction<
    typeof lazyIndex.ribbonPinnedMessageExtensionOnExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.ribbonPinnedMessageExtensionOnExecute);

registerLazyOrchestrator(
    onMessageExtensionTrigger,
    lazyModule,
    m => m.messageExtensionFlyoutCommandingOrchestrator
);
registerLazyOrchestrator(
    onClickMessageExtensionFlyoutButton,
    lazyModule,
    m => m.onClickMessageExtensionFlyoutButtonOrchestrator
);

registerLazyOrchestrator(
    launchAddinContextMenu,
    lazyModule,
    m => m.launchAddinContextMenuOrchestrator
);
registerLazyOrchestrator(onAddinTrigger, lazyModule, m => m.onAddinTriggerOrchestrator);
registerLazyOrchestrator(
    onAddinSubcommandsTrigger,
    lazyModule,
    m => m.onAddinSubcommandsTriggerOrchestrator
);
registerLazyOrchestrator(
    onMessageExtensionAddinsTrigger,
    lazyModule,
    m => m.onAddinMessageExtensionTriggerOrchestrator
);
registerLazyOrchestrator(onLaunchMetaOsAddIn, lazyModule, m => m.onLaunchMetaOsAddInOrchestrator);
registerLazyOrchestrator(onOpenAppStoreAddIns, lazyModule, m => m.onOpenAppStoreAddInsOrchestrator);

registerLazyOrchestrator(
    onPinMessageExtensionTrigger,
    lazyModule,
    m => m.onPinMessageExtensionOrchestrator
);
